var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderTaxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8332 6.99984C12.8332 9.74967 12.8332 11.1246 11.9786 11.9786C11.1252 12.8332 9.74967 12.8332 6.99984 12.8332C4.25 12.8332 2.87509 12.8332 2.0205 11.9786C1.1665 11.1252 1.1665 9.74967 1.1665 6.99984C1.1665 4.25 1.1665 2.87509 2.0205 2.0205C2.87567 1.1665 4.25 1.1665 6.99984 1.1665C9.74967 1.1665 11.1246 1.1665 11.9786 2.0205C12.5468 2.58867 12.7369 3.38725 12.8011 4.6665M10.4998 4.95817H8.1665M10.4998 8.45817H8.1665M10.4998 10.2082H8.1665M5.83317 4.95817H4.6665M4.6665 4.95817H3.49984M4.6665 4.95817V3.7915M4.6665 4.95817V6.12484M5.5415 8.45817L4.6665 9.33317M4.6665 9.33317L3.7915 10.2082M4.6665 9.33317L3.7915 8.45817M4.6665 9.33317L5.5415 10.2082",
    stroke: "#0D0706",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderTaxIcon);
export default __webpack_public_path__ + "static/media/order-tax-icon.3a3c9dae861ddaa6a4976d66775317c2.svg";
export { ForwardRef as ReactComponent };